import React from 'react';
import { Tag } from '../../../common/tags/tagTypes';
import { isEmpty } from 'lodash';
import TagsListElement from './TagsListElement';

type TagsListProps = {
    tagsArray: Array<Tag>;
    handleClickTag: (tagId: string) => void;
    handleClickEdit: (tagId: string) => void;
    isSelected?: boolean;
};

const TagsList: React.FC<TagsListProps> = ({ tagsArray, handleClickTag, handleClickEdit, isSelected }) => {
    if (isEmpty(tagsArray)) return null;

    return (
        <div className={`TagsList mb-3`}>
            {tagsArray.map(({ _id, name, color }) => (
                <TagsListElement
                    key={_id}
                    id={_id}
                    name={name}
                    color={color}
                    isSelected={isSelected}
                    handleClickTag={handleClickTag}
                    handleClickEdit={handleClickEdit}
                />
            ))}
        </div>
    );
};

export default TagsList;
